<mat-toolbar class="main-bar mat-elevation-z1" [attr.data-testid]="ELEMENT_IDS['cnt']">
  <button
    mat-icon-button
    class="toolbar-icon"
    aria-label="Open Menu Drawer"
    (click)="openDrawer()"
    [attr.data-testid]="ELEMENT_IDS['btn_menu_drawer']"
  >
    <mat-icon>keyboard_double_arrow_right</mat-icon>
  </button>

  <app-breadcrumb
    [style.display]="screenSize === 'small' ? 'none' : 'block'"
  ></app-breadcrumb>

  <span class="example-spacer"></span>

  <!-- <button
    mat-icon-button
    class="toolbar-icon"
    aria-label="Open Notification Drawer"
    (click)="openNotificationDrawer()"
    matBadge="&#8288;"
    matBadgeSize="small"
  >
    <mat-icon>notifications</mat-icon>
  </button> -->

  <button
    mat-icon-button
    class="toolbar-icon"
    aria-label="Open Account"
    [matMenuTriggerFor]="menu"
    [attr.data-testid]="ELEMENT_IDS['btn_account']"
  >
    <mat-icon>person</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <div class="menu-header">
      <!-- <div class="image"></div> -->
      <div class="account-details">
        <p class="account-name" [attr.data-testid]="ELEMENT_IDS['lbl_account_name']">{{ userData.name }}</p>
        <p class="account-role" [attr.data-testid]="ELEMENT_IDS['lbl_account_role']">{{ userData.role }}</p>
        @if(getSelectedWarehouse()){
          <p class="account-selected-warehouse" [attr.data-testid]="ELEMENT_IDS['lbl_selected_warehouse']">{{ getSelectedWarehouse() }}</p>
        }
      </div>
    </div>
    <div class="menu-item">
      @if(hasWarehouseOptions()){
        <button mat-button (click)="onSelectWarehouse()" [attr.data-testid]="ELEMENT_IDS['btn_select_warehouse']">
          Select Warehouse
          <mat-icon>house</mat-icon>
        </button>
      }
      <button mat-button [routerLink]="['/change-password']" [attr.data-testid]="ELEMENT_IDS['btn_change_password']">
        Change Password
        <mat-icon>lock</mat-icon>
      </button>
      <button mat-button [routerLink]="['/contact-us']" [attr.data-testid]="ELEMENT_IDS['btn_contact_support']">
        Contact Support
        <mat-icon>support_agent</mat-icon>
      </button>
    </div>
    <div class="divider-container">
      <div class="divider"></div>
    </div>
    <div class="menu-item">
      <button mat-button (click)="onLogout()" [attr.data-testid]="ELEMENT_IDS['btn_sign_out']">
        Sign Out
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>
